import { ReactNode } from "react"

import { X } from "lucide-react"

import { ActionTooltipButton } from "@/components/buttons/ActionTooltipButton"
import { DocumentPanel } from "@/components/panels/DocumentPanel"
import { Dialog, DialogContent } from "@ui/dialog"
import { cn } from "@/lib/utils"

interface DocumentModalProps {
    children: ReactNode
    document: string
    open: boolean
    setOpen: (open: boolean) => void
    removeFromCollection?: (document: string) => void
    className?: string
}
export function DocumentModal({ children, document, open, setOpen, removeFromCollection, className }: Readonly<DocumentModalProps>) {
    const handleRemoveFromCollection = () => {
        if (removeFromCollection) {
            removeFromCollection(document)
            setOpen(false)
        }
    }

    return (
        <>
            <div className={cn("flex items-center", className)} onClick={() => setOpen(true)}>
                {children}
            </div>

            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent className={"[&>button]:hidden p-0 gap-0 border-none w-[90vw] max-w-[90vw] h-[90vh] max-h-[90vh]"}>
                    <div className="flex flex-col h-full w-full">
                        <DocumentPanel id={document} removeFromCollection={removeFromCollection ? handleRemoveFromCollection : undefined}>
                            <ActionTooltipButton
                                icon={<X />}
                                variant="outline"
                                tooltip="Close Document"
                                onClick={() => setOpen(false)}
                            />
                        </DocumentPanel>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}